import { color } from "@mittwald/flow-styles/dist/tokens/ts/variables";
import styled from "styled-components";
import { InitialsOverlay } from "./InitialsOverlay";
import isPropValid from "@emotion/is-prop-valid";
export const Initial = styled.span.withConfig({
    shouldForwardProp: isPropValid,
}) `
  user-select: none;

  color: ${color.status.info.default};

  &:last-of-type {
    color: ${color.status.info.darker};
  }

  ${InitialsOverlay}.orange & {
    color: ${color.status.warning.default};

    &:last-of-type {
      color: ${color.status.warning.darker};
    }
  }

  ${InitialsOverlay}.green & {
    color: ${color.brand.secondary.default};

    &:last-of-type {
      color: ${color.brand.secondary.darker};
    }
  }

  ${InitialsOverlay}.violet & {
    color: ${color.brand.highlight.default};

    &:last-of-type {
      color: ${color.brand.highlight.darker};
    }
  }
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiSW5pdGlhbC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uL3NyYy9jb21wb25lbnRzL0F2YXRhci9zdHlsZWQvSW5pdGlhbC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEVBQUUsS0FBSyxFQUFFLE1BQU0sZ0RBQWdELENBQUM7QUFDdkUsT0FBTyxNQUFNLE1BQU0sbUJBQW1CLENBQUM7QUFDdkMsT0FBTyxFQUFFLGVBQWUsRUFBRSxNQUFNLG1CQUFtQixDQUFDO0FBQ3BELE9BQU8sV0FBVyxNQUFNLHdCQUF3QixDQUFDO0FBRWpELE1BQU0sQ0FBQyxNQUFNLE9BQU8sR0FBRyxNQUFNLENBQUMsSUFBSSxDQUFDLFVBQVUsQ0FBQztJQUM1QyxpQkFBaUIsRUFBRSxXQUFXO0NBQy9CLENBQUMsQ0FBQTs7O1dBR1MsS0FBSyxDQUFDLE1BQU0sQ0FBQyxJQUFJLENBQUMsT0FBTzs7O2FBR3ZCLEtBQUssQ0FBQyxNQUFNLENBQUMsSUFBSSxDQUFDLE1BQU07OztJQUdqQyxlQUFlO2FBQ04sS0FBSyxDQUFDLE1BQU0sQ0FBQyxPQUFPLENBQUMsT0FBTzs7O2VBRzFCLEtBQUssQ0FBQyxNQUFNLENBQUMsT0FBTyxDQUFDLE1BQU07Ozs7SUFJdEMsZUFBZTthQUNOLEtBQUssQ0FBQyxLQUFLLENBQUMsU0FBUyxDQUFDLE9BQU87OztlQUczQixLQUFLLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxNQUFNOzs7O0lBSXZDLGVBQWU7YUFDTixLQUFLLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxPQUFPOzs7ZUFHM0IsS0FBSyxDQUFDLEtBQUssQ0FBQyxTQUFTLENBQUMsTUFBTTs7O0NBRzFDLENBQUMifQ==